import axios from "@/axios.js"

export default {
  setDefaultSettings({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/calendar/set_default_settings", {
          item: item
        })
        .then((response) => {
          commit('SET_DEFAULT_SETTINGS', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchDefaultSettings(context, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/calendar/get_default_settings/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllDefaultSettings(context, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/calendar/get_all_user_default_settings/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addEvents({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/calendar/add_events", {
          item: item
        })
        .then((response) => {
          commit('ADD_EVENTS', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateEvent({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/calendar/update_event", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchUserEvents(context, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/calendar/get_user_events/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchEvent({
    commit
  }, eventId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/calendar/events/${eventId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  deleteEvent({
    commit
  }, eventId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/calendar/events/${eventId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  setScheduleAvailabilty({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/calendar/set_schedule_avalability", {
          item: item
        })
        .then((response) => {
          commit('SET_DEFAULT_SETTINGS', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchScheduleAvailabilites(context, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/calendar/get_schedule_availabilities/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  overridePreviousAllDayScheduled({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/calendar/override_previous_all_day_scheduled", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAvalabileTimeSlots({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/calendar/get_available_time_slots", {
          item: item
        })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
